import React from "react";
import {useCopyClipboard} from "../../utils/helpers";

const ResponseViewer = ({data, type}) => {
  const {copyStatus, handleCopyClipboard} = useCopyClipboard();
  return (
    <>
      <div className="highlight">
        <pre className="highlight json">
          <div className="copy-clipboard">
            <div id="copyIcon" onClick={() => handleCopyClipboard(data)}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>Copy to Clipboard</title>
                <path d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14z"></path>
              </svg>
            </div>
            <span id={copyStatus ? "active-requestBody" : "custom-tooltip"}>copied!</span>
          </div>
          <code style={type === "bodyParameter" ? {color: "#f0f8ff"} : {color: "#2E2E2E"}}>
            {JSON.stringify(data, null, 2)}
          </code>
        </pre>
      </div>
    </>
  );
};

export default ResponseViewer;
